import { render, staticRenderFns } from "./SettingText.vue?vue&type=template&id=26345186"
import script from "./SettingText.vue?vue&type=script&lang=ts"
export * from "./SettingText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports